/* global gsap */

/**
 *
 * @param {HTMLElement} element
 * @return {Boolean}
 */
const isInViewport = (element) => {
  const rect = element.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
};

export default class HeroGeometric {
  constructor($element) {
    if (isInViewport($element)) {
      this.timeline = gsap.timeline();
    } else {
      this.timeline = gsap.timeline({
        scrollTrigger: {
          trigger: $element,
          once: true,
          start: 'bottom bottom',
        },
      });
    }

    const heroGrid = $element.querySelector('[data-ref="hero-grid"]');
    const heroText = $element.querySelector('[data-ref="hero-text"]');
    const overlapStart = $element.querySelector('[data-ref="overlap-start"]');
    const overlapEnd = $element.querySelector('[data-ref="overlap-end"]');

    this.timeline.to(heroGrid, {
      autoAlpha: 1,
    }).to(heroText, {
      autoAlpha: 1,
      x: 0,
    }, '<').to(overlapStart, {
      xPercent: -52,
    }, '<').to(overlapEnd, {
      xPercent: 52,
    }, '<');
  }

  unmount() {
    this.timeline.kill();
  }
}
